import { DTIProps } from '@xometry/ui';
import cn from 'clsx';
import { FC, PropsWithChildren } from 'react';

import styles from './PageTitle.module.less';

interface PageTitleProps extends Partial<DTIProps> {
  className?: string;
}
export const PageTitle: FC<PropsWithChildren<PageTitleProps>> = ({ className, children, ...rest }) => {
  return (
    <h1 {...rest} className={cn(styles.container, className)}>
      {children}
    </h1>
  );
};
